// This optional code is used to register a service worker.
// register() is not called by default.

import { logger } from './utils/logger';

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          logger.debug('This web app is being served cache-first by a service worker.');
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // Check for updates ONLY on initial page load (once)
      registration.update();

      // NO periodic checks - update only happens on exit/close

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New service worker is available
              logger.debug('📱 New version downloaded! Will activate when app closes.');

              // Store that an update is available
              localStorage.setItem('pwa-update-available', 'true');

              // Tell the new service worker to skip waiting when page is hidden
              const activateOnHide = () => {
                if (document.hidden) {
                  installingWorker.postMessage({ type: 'SKIP_WAITING' });
                  document.removeEventListener('visibilitychange', activateOnHide);
                }
              };

              document.addEventListener('visibilitychange', activateOnHide);

              // Also activate if user explicitly closes/refreshes
              window.addEventListener('beforeunload', () => {
                installingWorker.postMessage({ type: 'SKIP_WAITING' });
              });

              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              logger.debug('Content is cached for offline use.');
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      logger.error('Error during service worker registration:', error);
    });

  // When new service worker takes control, reload to get fresh content
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing && localStorage.getItem('pwa-update-available') === 'true') {
      localStorage.removeItem('pwa-update-available');
      refreshing = true;
      // Only reload if the page is visible (user is looking at it)
      if (!document.hidden) {
        window.location.reload(true);
      }
    }
  });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      logger.debug('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        logger.error(error.message);
      });
  }
}
